import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M32.707 9.267A17.82 17.82 0 0 0 21.172 4.03V2.344h1.718a1.172 1.172 0 0 0 0-2.344h-5.78a1.172 1.172 0 0 0 0 2.344h1.718V4.03a17.8 17.8 0 0 0-8.336 2.682L9.379 5.598a2.85 2.85 0 0 0-2.03-.842c-.767 0-1.487.299-2.03.842L3.628 7.294a2.87 2.87 0 0 0 0 4.05l1.12 1.124a17.9 17.9 0 0 0-2.716 9.528c0 4.809 1.869 9.33 5.262 12.73A17.83 17.83 0 0 0 20 40c4.8 0 9.313-1.873 12.707-5.274a17.9 17.9 0 0 0 5.262-12.73c0-4.808-1.87-9.329-5.262-12.73M5.286 8.95l1.693-1.697a.52.52 0 0 1 .74 0l.85.851a18.3 18.3 0 0 0-2.433 2.437l-.85-.852a.524.524 0 0 1 0-.74M20 37.656c-8.616 0-15.625-7.025-15.625-15.66S11.385 6.336 20 6.336s15.625 7.025 15.625 15.66-7.01 15.66-15.625 15.66"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 8.534c-7.41 0-13.437 6.04-13.437 13.463S12.59 35.46 20 35.46c7.41 0 13.438-6.04 13.438-13.463 0-7.424-6.028-13.463-13.438-13.463m1.172 24.52v-1.37a1.172 1.172 0 0 0-2.344 0v1.37c-5.184-.548-9.315-4.689-9.86-9.885h1.345a1.172 1.172 0 0 0 0-2.344H8.968c.545-5.196 4.676-9.337 9.86-9.885v1.37a1.172 1.172 0 0 0 2.344 0v-1.37c5.184.548 9.315 4.689 9.86 9.885h-1.344a1.172 1.172 0 0 0 0 2.344h1.344c-.545 5.196-4.676 9.337-9.86 9.885"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.89 21.32h-1.652v-4.74a1.172 1.172 0 0 0-2.344 0v5.912c0 .647.525 1.171 1.172 1.171h2.825a1.172 1.172 0 0 0 0-2.343"
    }, null, -1)
  ]))]))
}
export default { render: render }